import React, { useEffect, useState } from "react";
import { sidebarItems } from "./sidebarItems";
// import Logo from "../logo/Logo";
// import Link from "next/link";
// import { usePathname, useRouter } from "next/navigation";
import { Icon } from "@iconify-icon/react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { selectAdmin } from "../../redux/admin/adminSlice";
import { logout } from "../../redux/auth/authSlice";
import styles from "./styles.module.css";
// import { useDispatch, useSelector } from "react-redux";
// import { getUserByIdFTN } from "@/redux/feature/auth/slice";

function Sidebar() {
  // const pathname = usePathname();
  const pathname = useLocation();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const admin = useSelector(selectAdmin);
  // console.log(admin?.role, "checking the admin")

  const filteredSidebarItems = sidebarItems.filter((item) => {
    if (admin?.role === "administrator") {
      return true;
    }
    return (
      item.name !== "Create Employee / Supervisor" && item.name !== "Create Form" && item.name !== "All Admins"
    );
  });


  return (
    <>
      <div
        className={`${
          show ? styles.icon : `${styles.showIcon} z-10 `
        }} fixed hidden `}
      >
        <Icon
          icon="ci:hamburger-lg"
          className="cursor-pointer text-[32px] transition-all"
          onClick={() => setShow(true)}
        />
      </div>
      <div
        className={` animation  bg-gradient-to-b from-blue-950 to-[#000] h-screen pr-20 ${
          show ? `  ${styles.showSidebar} z-10 ` : styles.sidebar
        }  transition-all ease-in `}
      >
        <div className="flex justify-around items-center  ">
          <h1 className="text-white mt-5 font-semibold text-2xl text-center">
            Avcon
          </h1>
          <Icon
            icon="maki:cross"
            className={`${
              show ? "block " : "hidden"
            } cursor-pointer text-white text-[21px] hover:bg-white  hover:text-[#214913]  hover:rounded-full`}
            onClick={() => setShow(false)}
          />
        </div>
        <ul className={`text-white  flex flex-col gap-2 mt-6   `}>
          {filteredSidebarItems.map((item, idx) => (
            <li
              key={idx}
              className={`flex relative  ${
                pathname.pathname === item.path
                  ? "before:w-1 before:h-full before:bg-white before:absolute before:left-0 before:rounded-tr before:rounded-br text-[#FEFEFE] font-semibold tracking-widest "
                  : "text-[#FFF]"
              } `}
            >
              <Link
                className={`flex items-center justify-center pl-6 py-1 gap-4 `}
                to={item.path}
              >
                {" "}
                <Icon
                  icon={item.icon}
                  className="text-xl w-[1.70rem] h-[1.60rem]"
                  alt={item.name}
                />
                {item.name}{" "}
              </Link>
            </li>
          ))}
        </ul>
        <div
          onClick={() => dispatch(logout())}
          className="px-2 py-3 ml-1 cursor-pointer rounded-lg absolute bottom-5 text-center lg:w-[12%] w-[50%]font-semibold mx-auto bg-white text-blue-950"
        >
          Logout
        </div>
      </div>
    </>
  );
}

export default Sidebar;
